import React from "react";

import { Login as ApiLogin } from "../../services/postApi";
import { useNavigate } from "react-router-dom"
import { isLogin } from "../../utils/isLogin";

/* eslint-disable jsx-a11y/anchor-is-valid */
function Login() {
  const redirect = useNavigate();

  const [loading, setLoading] = React.useState(false);
  const [isShowPass, setIsShowPass] = React.useState(false);
  const [valid, setValid] = React.useState({
    msg: "",
    isValid: false
  });

  React.useEffect(()=> {
    if(!isLogin('token')){
      redirect('/panel')
    }
  },[])

  const handleLogin = async (e) => {
    e.preventDefault();
    if (e.target.password.value.trim() == "") {
      setValid({ ...valid, msg: "لطفا کلمه عبور را وارد کنید", isValid: true })
      return false
    }
    let data = {
      password: e.target.password.value
    }
    setLoading(true);
    ApiLogin(data).then(res => {
      localStorage.setItem('token',res?.token);
      localStorage.setItem('validityTime',res?.validityTime);
      redirect('/');
    })
      .catch(err => {
        setLoading(false);
        if(err.code == "ERR_NETWORK"){
          setValid({ ...valid, msg: "خطا در بر قراری ارتباط", isValid: true })
        }
        setValid({ ...valid, msg: err.response?.data.message, isValid: true })
        document.getElementById("password").focus();
        e.target.reset();
      })
  };

  const getvalueChange = () => {
    setValid({ msg: "", isValid: false });
  }

  const getIsTheme = (e) => {
    if (e.target.checked) {
      document.getElementsByTagName("html")[0].setAttribute('data-theme', "dark");
      localStorage.setItem('theme', "dark")
    } else {
      document.getElementsByTagName("html")[0].setAttribute('data-theme', "light");
      localStorage.setItem('theme', "light")
    }
  }

  return (
    <div className="hero min-h-screen bg-base-200">
      <label class="swap swap-rotate fixed left-4 bottom-4">
        <input type="checkbox" onChange={getIsTheme} defaultChecked={true} />
        <svg class="swap-on fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" /></svg>
        <svg class="swap-off fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" /></svg>
      </label>
      <form
        className="hero-content flex-col lg:flex-row-reverse w-full page-ani"
        onSubmit={handleLogin}
      >
        <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
          <div className="card-body">
            <h1 className="text-center mb-2 text-[22px]">
              سیستم مدیریتی هتل داری
            </h1>
            <h1 className="text-center my-1">مهمانسرا دانشگاه شمال</h1>
            <div className="form-control">
              <label className="label">
                <span className="label-text">کلمه عبور</span>
              </label>
              <input
                type={isShowPass ? "text" : "password"}
                id="password"
                name="password"
                placeholder="کلمه عبور خود را وارد کنید"
                className={`input input-bordered ${valid.isValid ? "input-error" : ""}`}
                onChange={getvalueChange}
              />
              {
                valid.isValid ?
                  <small className="mt-2 mr-1 text-error">{valid.msg}</small>
                  : null
              }
            </div>
            <label className="label cursor-pointer d-[inline]">
              <span className="label-text">مشاهده رمز عبور</span>
              <input
                type="checkbox"
                onClick={() => setIsShowPass(!isShowPass)}
                checked={isShowPass}
                className="checkbox checkbox-primary"
              />
            </label>
            <div className="form-control mt-6">
              <button
                type="sebmit"
                dir='ltr'
                className={`btn btn-primary d-flex justify-center items-center ${loading ? "loading" : ""}`}
              >
                {loading ? "درحال بررسی اطلاعات" : "وارد شدن"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Login;
